<template>
  <div class="home">
      <!-- <Header></Header> -->
      
    <div class="home_content">
        <video muted id="myVideo" v-if="!this.isMobile()">
            <source src="@/assets/images/video/home.mp4" type="video/mp4">
        </video>
        <img src="@/assets/images/Home/landing.jpg" alt="" class="responsive-bg" v-if="this.isMobile()">
        <div class="container">
            <div class="lang">
                <langSwitch></langSwitch>
            </div>
            <div class="rotateImages">
                <img src="@/assets/images/Home/SVG/landing-graphic-1.svg" class="landing-graphic-1">
                <img src="@/assets/images/Home/SVG/landing-graphic-2.svg" class="landing-graphic-2">
                <img src="@/assets/images/Home/SVG/landing-graphic-3.svg" class="landing-graphic-3">
            </div>
            <div class="video_label">
                <div class="video_label-main_content">
                    <a href="">
                    <div class="zain_logo">
                        <img src="@/assets/images/svg/logo.svg" alt="" class="img-fluid">
                    </div>
                    </a>
                    <div class="video_label-wrapper">
                        <div class="tagLine_heading">
                            <h1 class="text-white">
                                {{$t('Home.title_line1')}}<br>
                                {{$t('Home.title_line2')}}<br>
                                {{$t('Home.title_line3')}}
                            </h1>
                            <span>{{$t('Home.subtitle')}}</span>
                        </div>
                        <div class="hover_btn">
                            <router-link :to="`/${$i18n.locale}/table-of-contents`">
                                <div class="pulse-dot">
                                    <div class="pulse-wrapper">
                                        <div class="pulse pulse-1"></div>
                                        <div class="pulse pulse-2"></div>
                                        <div class="pulse pulse-3"></div>
                                    </div>
                                </div>
                                {{$t('Home.start')}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="loader-wrapper">
      <div id="loader">
        <img img fluid src="@/assets/images/svg/logo.svg" alt="" />
      </div>
      <div class="loader-section section-left"></div>
      <div class="loader-section section-right"></div>
    </div>
  </div>
</template>

<script>
 import {gsap} from "gsap"
 import { SplitText } from "gsap/SplitText";
 import util from '@/mixin/util.js';
 import langSwitch from "@/common/layout/partials/languageSwitch.vue";
gsap.registerPlugin(SplitText);
export default {   
  name: 'Home',
  mixins: [util],
  components: {
    langSwitch
  },
  methods:{
      videoAnimation(){
          const rounded = document.querySelector('.rotateImages');
          const Logo = document.querySelector('.zain_logo img');
          const heading = document.querySelector('.tagLine_heading h1');
          const sub_heading = document.querySelector('.tagLine_heading span');
          const link = document.querySelector('.hover_btn a');
          gsap.set(heading, { autoAlpha: 1 })
          gsap.set(sub_heading, { autoAlpha: 1 })
          let timeLine = gsap.timeline();
          let split = new SplitText(heading, { type: "lines" });
          timeLine.fromTo(rounded,{autoAlpha:0},{autoAlpha:1,duration:0.5,ease:"power4.Out"})
          timeLine.fromTo(Logo,{autoAlpha:0, opacity: 0, y: 150},{autoAlpha:1,duration:0.5, y: 0, opacity: 1, ease:"power4.Out"} , "-=.1")
          timeLine.fromTo(split.lines, { y: 200, autoAlpha: 0 }, { autoAlpha: 1, y: 0, duration: 1, stagger: { from: "start", each: 0.3 } }, "+=.2")
          timeLine.fromTo(sub_heading,{autoAlpha:0},{autoAlpha:1,duration:0.5,ease:"power4.Out"} , "+=.2")
          timeLine.fromTo(link,{autoAlpha:0},{autoAlpha:1,duration:0.5,ease:"power4.Out"} , "+=1")
          
      },
      playAnimation(){
          setTimeout(() => {
              if(!this.isMobile())
              {
                  document.getElementById("myVideo").play();
              }
              this.videoAnimation()
          }, 100);
      }
  },
  mounted(){
    document.body.classList.add("no-scroll");
    if(document.body.classList.contains('loaded')){
        this.playAnimation();
    }
    else{
        setTimeout(() => {
        document.body.classList.add("loaded");
        this.playAnimation();
        }, 2000);
    }
  }
}
</script>
<style lang="scss">
    // .verticalLabel{
    //     display:none !important;
    // }
</style>
<style lang="scss" scoped>
.home{
    height: 100vh;
    overflow: hidden;
    padding: 0px 15px;
    position: relative;
    .container{
        position: relative;
    }
    .lang{
        position: absolute;
        top: rem(20px);
        right: 0;
    }
    scrollbar-color: #f0e81b #9b9c9e;
        scrollbar-width: thin;
        ::-webkit-scrollbar {
            width: 10px;
            height: 8px;
        }
        ::-webkit-scrollbar-track {
            background: #9b9c9e; 
        }
        ::-webkit-scrollbar-thumb {
            background: #f0e81b; 
            transition: 0.5s ease all;
        }
        ::-webkit-scrollbar-thumb:hover {
            background: #cfc904; 
        }
    @media only screen and (orientation: landscape) and (max-width:767px) {
        overflow: auto;
        
    }
    @media only screen and (orientation: landscape) and (max-width:991px) and (min-width:768px) {
        overflow: hidden;
        
    }
    .responsive-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        left: 0;
        top: 0;
        z-index: -1;
    }
    #myVideo {
        position: fixed;
        right: 0;
        bottom: 0;
        min-width: 100vw;
        min-height: 100vh;
        z-index: -1;
        object-fit: cover;
        @media screen and (min-width:768px) and (max-width:1024px){
            width: 100%;
            height: 100%;
            object-position: center right;
        }
        @media screen and (max-width:991px){
            object-position: 70% center;
            width: 100vw;
            height: 100vh;
        }
    }
    // background:url(../assets/images/Home/bannerImge.jpg) top right no-repeat;
    // background-size: cover;
    
    .home_content{
        .rotateImages{
            position: relative;
            visibility: hidden;
            @media screen and (max-width:767px) {
                display: none;
            }
            .landing-graphic-1{
                position: absolute;
                right: 80px;
                top: 40px;
                z-index: 1;
                width: 110px;
                animation: rotation 8s infinite linear;
            }
            .landing-graphic-2{
                position: absolute;
                right: -62px;
                top: 130px;
                z-index: 1;
                width: 171px;
                @media screen and (max-width:991px){
                    right:0px;
                }
            }
            .landing-graphic-3{
                height: 70px;
                position: absolute;
                right: -20px;
                top: 113px;
                z-index: 1;
                width: 90px;
                animation: rotation 6s infinite linear;
                @media screen and (max-width:991px){
                    right:-15px;
                }
            }
            @keyframes rotation {
                from{
                    transform: rotate(0deg);
                }
                to{
                    transform: rotate(360deg);
                }
            }
        }
        .video_label{
            min-height: 100vh;
            display: flex;
            align-items: center;
            @media screen and (min-width:768px) and (max-width:1024px){
                min-height: 100%;
            }
            @media screen and (max-width: 991px){
                align-items: flex-start;
            }
            &-main_content{
                width: 100%;
                height: auto;
                // @media screen and (max-width:991px) {
                //     max-width: 600px;
                //     margin: auto;
                // }
                @media screen and (max-width:767px) {
                    max-width: 350px;
                }
                .zain_logo{
                    width: 235px;
                    display: inline-block;
                    padding:rem(50px) 0;
                    @media screen and (max-width:767px) {
                        width: 170px;
                    }
                    img{
                        visibility: hidden;
                    }
                }
                .tagLine_heading{
                    padding: rem(80px) rem(0px);
                        @media screen and (min-width:768px) and (max-width:1024px){
                            padding: rem(80px) rem(0px);
                        }
                       @media screen and  (max-width:767px) and (orientation: portrait){
                           padding: unset;
                            padding-top: rem(10px);
                        } 
                    h1{
                        font-size: rem(55px);
                        font-weight: 900;
                        text-transform: uppercase;
                        line-height: 1;
                        visibility: hidden;
                        @media screen and (max-width:767px) {
                            font-size: rem(35px);
                            line-height: 1.5;
                        }
                    }
                    span{
                        font-size: rem(35px);
                        color: #f2eb0b;
                        visibility: hidden;
                        @media screen and (max-width:600px) {
                            font-size: rem(28px);
                        }
                    }
                }
                .hover_btn{
                    a{
                        position: relative;
                        margin-left: 40px;
                        display: inline-flex;
                        text-transform: uppercase;
                        color: #fff;
                        letter-spacing: 5px;
                        text-decoration: none;
                        font-size: rem(18px);
                        visibility: hidden;
                        margin: 20px 0px 20px 40px;
                        @media screen and (orientation: portrait) and (max-width:767px) {
                            position: absolute;
                            bottom: 100px;
                        }
                        &::before{
                            content: "";
                            width: 120px;
                            transition: all 0.1s ease;
                            opacity: 0;
                            height: 100%;
                            position: absolute;
                            top: 50%;
                            left: 50px;
                            background: white;
                            transform: translateY(-50%) skewX(-10deg);
                        }
                        &::after{
                            content: "";
                            width: 100px;
                            transition: all 0.2s ease;
                            opacity: 0;
                            height: 100%;
                            position: absolute;
                            top: 50%;
                            left: 50px;
                            background: white;
                            transform: translateY(-50%) skewX(-10deg);
                        }
                        &:hover{
                            &::before{
                                width: 2px;
                                opacity: 1;
                                left: calc(100% + 6px);
                            }
                            &::after{
                                width: 2px;
                                opacity: 1;
                                left: calc(100% + 6px);
                            }
                        }
                        .pulse-dot {
                            width: 11px;
                            height: 11px;
                            border-radius: 50px;
                            display: block;
                            background: white;
                            position: absolute;
                            top: 50%;
                            left: -40px;
                            transform: translateY(-50%);
                            .pulse-wrapper {
                                position: absolute;
                                width: 35px;
                                height: 35px;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                z-index: -1;
                                .pulse {
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 100%;
                                    top: 0;
                                    left: 0;
                                    opacity: 0.1;
                                    background: #fff;
                                    &.pulse.pulse-1 {
                                        animation: pulse-animation2 3s infinite; 
                                    }
                                    &.pulse.pulse-2 {
                                        animation: pulse-animation2 3s infinite;
                                        animation-delay: -0.8s;
                                    }
                                    &.pulse.pulse-3 {
                                        animation: pulse-animation2 3s infinite;
                                        animation-delay: -1.4s;
                                    }
                                    
                                }
                            }
                        }
                        @keyframes pulse-animation2 {
                                0% {
                                    transform: scale(0);
                                    opacity: 1;
                                    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.5);
                                }
                                100% {
                                    transform: scale(1);
                                    opacity: 0;
                                    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
                                }
                            }
                    }
                }
            }
        }
    }
    @media only screen and (orientation: landscape) and (max-width:991px) and (min-width:768px) {
        overflow: hidden;
        .home_content {
            .video_label-main_content {
                .tagLine_heading{
                    padding:rem(20px) 0 0 0;
                    h1{
                        font-size:rem(45px);
                    }
                }
                .hover_btn{
                    a{
                        margin-top:20px;
                    }
                }
            }
        }
        
    }
}
#loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1003;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
#loader {
//   display: block;
//   position: relative;
//   left: 0;
//   top: 0;
//   width: 300px;
//   transform: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
  img{
      width: 200px;
      height: auto;
  }
}
#loader-wrapper .loader-section {
  position: fixed;
  top: 0;
  width: 51%;
  height: 100%;
  background: #fff;
  z-index: 1000;
}
#loader-wrapper .loader-section.section-left {
  left: 0;
}
#loader-wrapper .loader-section.section-right {
  right: 0;
}
.loaded #loader-wrapper .loader-section.section-left {
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%);
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.loaded #loader-wrapper .loader-section.section-right {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.loaded #loader {
  opacity: 0;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.loaded #loader-wrapper {
  visibility: hidden;
  -webkit-transform: translateY(-100%);
  -ms-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition: all 0.3s 1s ease-out;
  transition: all 0.3s 1s ease-out;
}
#loader img {
  max-width: 100%;
}
.modal-open {
  overflow: hidden;
}

// arabic
[lang="ar"] {
    .home{
        padding-left: 15px;
        padding-right: 15px;
        .lang{
            right: auto;
            left: 0;
        }
        .responsive-bg{
            right: 0;
            left: 0;
        }
        #myVideo {

            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            left: 0;
            right: auto;
        }
        
        .home_content{
            .rotateImages{
                .landing-graphic-1{
                    left: 80px;
                    right: auto;
                }
                .landing-graphic-2{
                    left: -52px;
                    right: auto;
                    @media screen and (max-width:991px){
                        left:0px;
                        right: auto;
                    }
                }
                .landing-graphic-3{
                    
                    left: -20px;
                    right: auto;
                    
                    @media screen and (max-width:991px){
                        left:-15px;
                        right: auto;
                    }
                }
                
            }
            .video_label{
                
                &-main_content{
                    
                    .hover_btn{
                        a{
                            // margin-right: 40px;
                            // margin-left: 0px;
                            padding-right:40px;
                            letter-spacing: normal;
                            &::before{
                                right: 50px;
                                left: auto;
                            }
                            &::after{
                                right: 50px;
                                left: auto;
                            }
                            &:hover{
                                &::before{
                                    right: calc(100% + 6px);
                                    left: auto;
                                }
                                &::after{
                                    right: calc(100% + 6px);
                                    left: auto;
                                }
                            }
                            .pulse-dot {
                                right: 0px;
                                left: auto;
                            } 
                        }
                    }
                    .tagLine_heading{
                        padding:rem(60px) 0;
                        h1{
                            line-height:1.2;
                        }
                    }
                }
            }
        }
        
    }
    // #loader-wrapper {
    //     right: 0; left: auto;
    // }
    // #loader-wrapper .loader-section.section-left {
    //     right: 0; left: auto;
    // }
    // #loader-wrapper .loader-section.section-right {
    //     left: 0; right: auto;
    // }
}



</style>